import { render } from "./pageTopic.vue?vue&type=template&id=c6e8325c&scoped=true"
import script from "./pageTopic.vue?vue&type=script&lang=js"
export * from "./pageTopic.vue?vue&type=script&lang=js"

import "./pageTopic.vue?vue&type=style&index=0&id=c6e8325c&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6e8325c"]])

export default __exports__